import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { Grid, Paper, Button, Link } from '@material-ui/core';
import DataTable from '../../components/DataTable/DataTable'
import styles from '../App.css';
import Translation from '../../components/Translation/Translation';

@inject('customerCaseStore')
@observer
export default class Users extends Component
{
  constructor(props) {
    super(props);
    this.allTemplates = [];
    this.searchParam = null;
    this.state = {
      head: [
        <Translation>name</Translation>,
      ],
      templates: []
    };
  }

  onSearch(val) {
    this.searchParam = val.trim().toLowerCase();
    this.updateFilteredTemplates();
  }

  updateFilteredTemplates() {
    let templates = this.allTemplates;

    if (this.searchParam && this.searchParam !== "") {
      templates = this.allTemplates.filter(template => template.name.props.children.toLowerCase().includes(this.searchParam));
    }

    this.setState({templates});
  }

  add() {
    this.props.history.push('/create/template');
  }

  componentDidMount() {
    this.props.customerCaseStore.getTemplates()
      .then((templates) => {
        let prettyTemplates = templates.map(template => {
          return {
            name: (<Link to={`/templates/${template._id}`} component={RouterLink}>{template.name}</Link>),
          }
        });

        this.allTemplates = prettyTemplates;
        this.setState({templates: prettyTemplates});
      })
  }

  renderData() {
    const { head, templates } = this.state;

    return (
      <DataTable
        head={head}
        data={templates}
        onSearch={this.onSearch.bind(this)}
      />
    )
  }

  render() {
    return (
      <Grid item xs={12}>
        {this.renderData()}

        <Button style={styles.marginTop} onClick={this.add.bind(this)} variant="raised" color="primary">{<Translation>nav.addNewTemplate</Translation>}</Button>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/TemplatesList/TemplatesList.jsx